// components/RAGInitializer.jsx
import { useEffect } from 'react';
import { useInitialiserRAGMutation } from 'actions/rag_compte/mutations';

/**
 * Composant pour initialiser le service RAG au démarrage de l'application
 * Compatible avec RTK Query
 */
const RAGInitializer = () => {
  const [initialiserRAG] = useInitialiserRAGMutation();
  
  useEffect(() => {
    // Initialiser le service RAG une seule fois au montage
    initialiserRAG()
      .unwrap()
      .then(() => {
        console.log('✅ Service RAG initialisé avec succès');
      })
      .catch((error) => {
        console.warn('⚠️ Service RAG non disponible:', error.message || error);
        // L'application continue de fonctionner sans suggestions
      });
  }, []);

  // Ce composant ne rend rien
  return null;
};

export default RAGInitializer;